module.exports = __webpack_public_path__ + "img/star-fill-blue.bc2d81c9.svg";